import { createSelector } from '@ngrx/store';

import { getAuthState } from '../state';
import { AuthState } from './reducer';

export const getAuthIsAuthenticated = createSelector(
    getAuthState,
    (state: AuthState) => state.isAuthenticated,
);

export const getAuthError = createSelector(getAuthState, (state: AuthState) => state.errorText);

export const getAuthSessionMessageKey = createSelector(
    getAuthState,
    (state: AuthState) => state.sessionMessageKey,
);

export const getAuthSessionMessageParams = createSelector(
    getAuthState,
    (state: AuthState) => state.sessionMessageParams,
);

export const getAuthTwoFactorChallenge = createSelector(
    getAuthState,
    (state: AuthState) => state.twoFactorChallenge,
);

export const getAuthTwoFactorErrorKey = createSelector(
    getAuthState,
    (state: AuthState) => state.twoFactorErrorKey,
);

export const getAuthIsTwoFactorSubmitting = createSelector(
    getAuthState,
    (state: AuthState) => state.isTwoFactorSubmitting,
);

export const getAuthTwoFactorResendAvailableAt = createSelector(
    getAuthState,
    (state: AuthState) => state.twoFactorResendAvailableAt,
);
